import type { Contact } from '@/api/queries/conversations';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Edit } from 'lucide-react';
import { getContactInitials } from './contactUtils';

interface ContactItemProps {
  contact: Contact;
  onClick: (contact: Contact) => void;
  showEditButtons?: boolean;
  disabled?: boolean;
}

export function ContactItem({
  contact,
  onClick,
  showEditButtons,
  disabled = false,
}: ContactItemProps) {
  const handleClick = () => {
    onClick(contact);
  };

  return (
    <div className="relative group" data-testid={`contact-item-${contact.id}`}>
      <button
        onClick={handleClick}
        className="w-full py-3.5 hover:bg-gray-50 flex items-center gap-3 text-left transition-colors duration-200"
        data-testid={`contact-item-select-button-${contact.id}`}
        disabled={disabled}
      >
        <Avatar className="w-10 h-10">
          <AvatarFallback>{getContactInitials(contact.name)}</AvatarFallback>
        </Avatar>
        <div className="flex-1 min-w-0">
          <div className="font-medium text-gray-900 truncate text-sm">{contact.name}</div>
        </div>

        {showEditButtons && (
          <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            <Edit className="w-4 h-4" />
          </div>
        )}
      </button>
    </div>
  );
}
